import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import { FeatureSnapshot } from 'components/FeatureSnapshot';
import refer from "../../../../contents/images/startup-refer.png";
import * as React from 'react';
export default {
  getImage,
  GatsbyImage,
  FeatureSnapshot,
  refer,
  React
};